import { parseColorHexRGB } from '@microsoft/fast-colors';
import { getWebRGBA } from './colors.util';
/**
 * @internal
 */
const rapidTextFieldTextColor = parseColorHexRGB('#F1F1F1');
const textFieldTextAlpha = 1;
export const defaultRapidTextColor = getWebRGBA(rapidTextFieldTextColor, textFieldTextAlpha);
/**
 * @internal
 */
const rapidTextFieldBGColor = parseColorHexRGB('#879BA6');
const textFieldBGAlpha = 0.06;
export const defaultRapidBGColor = getWebRGBA(rapidTextFieldBGColor, textFieldBGAlpha);
/**
 * @internal
 */
const rapidTextFieldLabelColor = parseColorHexRGB('#879BA6');
const textFieldLabelAlpha = 1;
export const defaultRapidLabelColor = getWebRGBA(rapidTextFieldLabelColor, textFieldLabelAlpha);
/**
 * @internal
 */
const rapidTextFieldActiveBGColor = parseColorHexRGB('#121212');
const textFieldActiveBGAlpha = 1;
export const defaultRapidActiveBGColor = getWebRGBA(rapidTextFieldActiveBGColor, textFieldActiveBGAlpha);
/**
 * @internal
 */
const rapidTextFieldBorderUnfocusedColor = parseColorHexRGB('#2e3339');
const rapidTextFieldBorderUnfocusedColorAlpha = 1;
export const defaultRapidBorderUnfocusedColor = getWebRGBA(rapidTextFieldBorderUnfocusedColor, rapidTextFieldBorderUnfocusedColorAlpha);
export var ZeroAppearanceColor;
(function (ZeroAppearanceColor) {
    ZeroAppearanceColor["PrimaryBlue"] = "primary-blue";
    ZeroAppearanceColor["PrimaryPurple"] = "primary-purple";
    ZeroAppearanceColor["PrimaryGradient"] = "primary-gradient";
    ZeroAppearanceColor["SecondaryOrange"] = "secondary-orange";
    ZeroAppearanceColor["SecondaryTeal"] = "secondary-teal";
    ZeroAppearanceColor["NeutralGrey"] = "neutral-grey";
    ZeroAppearanceColor["OutlinePrimaryGradient"] = "outline-primary-gradient";
    ZeroAppearanceColor["OutlineSecondaryOrange"] = "outline-secondary-orange";
    ZeroAppearanceColor["OutlineSecondaryTeal"] = "outline-secondary-teal";
})(ZeroAppearanceColor || (ZeroAppearanceColor = {}));
export const FastAppearanceValues = ['accent', 'lightweight', 'neutral', 'outline', 'stealth'];
export const ZeroAppearanceValues = Object.values(ZeroAppearanceColor);
